import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTheme } from 'emotion-theming';
import { Icon } from '@lyearn-team/frontend-components';
import styles from './styles';
import CertificateIframe from './CertificateIframe';

@withTheme
class Certificate extends Component {
  renderCertificateCloseButton = () => {
    const { closeButton } = this.props;
    if (!closeButton) {
      return null;
    }
    return (
      <div
        className={styles.certificateCloseButton()}
        onClick={event => this.props.onLayoutCloseClick(event)}
      >
        <Icon
          type="close"
          style={{
            width: '18px',
            height: '24px',
            marginRight: '7px',
            fill: this.props.theme.color.black3
          }}
          scale={1.2}
        />
      </div>
    );
  };

  render() {
    // eslint-disable-next-line no-unused-vars, max-len
    const {
      includeScore,
      includeCompletionDate,
      includeApprover,
      dontPublishOnLinkedIn,
      companyImage,
      userName,
      score,
      instructorName,
      completionDate,
      activityType,
      activityTitle
    } = {
      ...this.props.certificateSettings,
      ...this.props.companyDetails,
      ...this.props.userDetails,
      ...this.props.certificateDetails,
      ...this.props.style
    };
    const { showClose, style } = this.props;
    let evaledCertificate = '<p>Sorry some occured. Please try agian later.</p>';
    const parsedCertificate = `function test() {var a = \`${JSON.stringify(
      this.props.previewCertificateTemplate
    )}\`; return a} test()`;
    try {
      // eslint-disable-next-line no-eval
      evaledCertificate = eval(parsedCertificate);
      evaledCertificate = evaledCertificate.substr(1).slice(0, -1);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Some Error Occured ->', error);
    }

    return (
      <div style={style}>
        {showClose ? this.renderCertificateCloseButton() : null}
        <div dangerouslySetInnerHTML={{ __html: evaledCertificate }} />
        <CertificateIframe>
          <div dangerouslySetInnerHTML={{ __html: evaledCertificate }} />
        </CertificateIframe>
      </div>
    );
  }
}

Certificate.propTypes = {
  certificateSettings: PropTypes.shape({
    includeScore: PropTypes.bool,
    includeCompletionDate: PropTypes.bool,
    includeApprover: PropTypes.bool,
    dontPublishOnLinkedIn: PropTypes.bool
  }).isRequired,
  companyDetails: PropTypes.shape({
    companyName: PropTypes.string,
    companyImage: PropTypes.string
  }),
  userDetails: PropTypes.shape({
    userName: PropTypes.string,
    emailId: PropTypes.string
  }),
  previewCertificateTemplate: PropTypes.string.isRequired,
  certificateDetails: PropTypes.shape({
    score: PropTypes.string,
    instructorName: PropTypes.string,
    completionDate: PropTypes.string,
    activityType: PropTypes.string,
    activityTitle: PropTypes.string
  }),
  showClose: PropTypes.bool
};
Certificate.defaultProps = {
  companyDetails: {
    companyName: 'Lyearn',
    companyImage:
      'https://dndw32r4edmw5.cloudfront.net/lyearn/lyearnWebsite/images/lyearn-gray-logo.png'
  },
  userDetails: {
    userName: 'John Doe',
    emailId: 'john.doe@example.com'
  },
  certificateDetails: {
    score: '100%',
    instructorName: 'Johny Silva',
    completionDate: '16th October 2018',
    activityType: 'course',
    activityTitle: 'Command of the Message'
  },
  showClose: true
};

export default Certificate;
